import React, { Component } from 'react';
import PropTypes from 'prop-types';


import { LinkedInClicked, TwitterButtonAnalytics } from '../../../utils/Analytics.js';
import SocialButton from './SocialButton.jsx';

const url = window.location.href;

class LinkedinButton extends Component {
    constructor(props) {
        super(props);
        this.state = {
            imageSrc: null
        };

        this.url = `https://www.linkedin.com/sharing/share-offsite/?url=${url}`

       
    }

    render() {
        const color = this.props.color;
        return (
            <SocialButton
                imageSrc='https://cdn.obsess-vr.com/ferragamo/icon-linkedin-white.svg'
                style={this.props.style}
                redirectUrl={this.url}
                color={color}
                onClickAnalytics={LinkedInClicked}
            />
        );
    }
}

LinkedinButton.propTypes = {
    style: PropTypes.object
};

export default LinkedinButton;
